// Generate code from clean architecture template

import { ConfigSystemEntity } from '../entities';
import { QueryConfigSystemPayload } from '../ports/payloads';
import { ConfigSystemRepository } from '../ports/repositories';

export class FindByKeyConfigSystemUsecase {
  constructor(private readonly repo: ConfigSystemRepository) {}

  async run(payload: QueryConfigSystemPayload): Promise<ConfigSystemEntity | undefined> {
    const entity = await this.repo.findByKey(payload);
    return entity;
  }
}
